/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Button/theme';

export const ButtonTheme = theme;
